'use strict';

require("moduleFold/notifiche/scripts/index.js");
require("moduleFold/datasource/scripts/index.js");
var BssBasicField = require("moduleFold/formbuilder/scripts/mixins/BssBasicField");

//    DA RISOLVERE NON SI PRENDE LA LARGHEZZA A DISPOSIZIONE E NON APRE IL COLORPICKER FUNZIONA SOLO L'INSERIMENTO DEL COLORE DA CAMPO DI TESTO

/**
 * Campo di tipo entity su entity esterna
 * 
 * @class  
 * @param {type} formlyConfig
 * @param {type} formlyValidationMessages
 * @param {Valida} Valida
 */
function BSSColorpicker(formlyConfig, formlyValidationMessages, Valida){
    formlyConfig.setType($.extend(true, {}, new BssBasicField(), {
        name: 'bsscolorpicker', 
        //extends: 'bssinput',
        template: require("./bsscolorpicker.html"),
        controller: ["$scope", "$rootScope", "$filter", "$timeout", "$http", "$state", "ErrorManager", "DSFactory", require("./BssColorpickerController")],
        defaultOptions: {
            ngModelElAttrs: {
                'cssCategory': 'bsscolorpicker'
            },
        }
    }));
}

module.exports = BSSColorpicker;